import { Grid, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { useIntl } from 'react-intl'
import { NavLink } from 'react-router-dom'
import { getTopBarNavigationLinks } from '../../constants'
import { TopBarTopLinkProps } from '../../types'

const useStyles = makeStyles((theme) => ({
  navLink: {
    borderBottom: '4px solid transparent',
    color: theme.variables.colors.navigation.navLink.color,
    textDecoration: 'none',
    textTransform: 'uppercase',
    '&:hover': {
      borderBottom: `4px solid ${theme.variables.colors.navigation.navLinkActive.borderBottom}`
    }
  },
  navLinkActive: {
    borderBottom: `4px solid ${theme.variables.colors.navigation.navLinkActive.borderBottom}`,
    textDecoration: 'none'
  }
}))

export interface DesktopLinksProps {
  useAdminTool: boolean
}

export const DesktopLinks = ({ useAdminTool }: DesktopLinksProps) => {
  const classes = useStyles()

  const { formatMessage } = useIntl()

  return (
    <Grid container direction="row" spacing={6}>
      {getTopBarNavigationLinks(useAdminTool).map(
        (link: TopBarTopLinkProps) => (
          <Grid
            item
            key={link.key}
            style={{
              paddingLeft: '20px'
            }}
          >
            <Typography>
              <NavLink
                activeClassName={classes.navLinkActive}
                className={classes.navLink}
                exact={link.exact}
                to={link.to}
              >
                {formatMessage({ id: link.translationId })}
              </NavLink>
            </Typography>
          </Grid>
        )
      )}
    </Grid>
  )
}
